import { render, staticRenderFns } from "./SliderBox.vue?vue&type=template&id=00dfc2a6"
import script from "./SliderBox.vue?vue&type=script&lang=js"
export * from "./SliderBox.vue?vue&type=script&lang=js"
import style0 from "./SliderBox.vue?vue&type=style&index=0&id=00dfc2a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports